import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/css/reset.css";
import "./assets/css/styles.css";

if (typeof window !== "undefined") {
  const params = new URLSearchParams(window.location.search);
  if (params.get("embed") === "1") {
    document.documentElement.classList.add("is-embed");
    document.body.classList.add("is-embed");

    const embedContext = params.get("embedCtx");
    if (embedContext === "modal") {
      document.documentElement.classList.add("is-embed-button");
      document.body.classList.add("is-embed-button");
    }

    const existingScript = document.querySelector<HTMLScriptElement>(
      'script[data-iframe-resizer="child"]'
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/iframe-resizer@4.4.5/js/iframeResizer.contentWindow.min.js";
      script.async = true;
      script.setAttribute("data-iframe-resizer", "child");
      document.head.appendChild(script);
    }
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
